import { api } from '@/lib/api';
import { getClientSessionOrThrow } from '@/lib/client-session-auth';

/**
 * Confirm user age (18+) by updating profile
 */
export const confirmAgeReq = async (): Promise<{ success: boolean; error?: string }> => {
  try {
    const { accessToken } = await getClientSessionOrThrow();

    await api.patch(
      '/api/users/profile',
      { isAdult: true },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return { success: true };
  } catch (error) {
    console.error('Error confirming age:', error);
    return { success: false, error: 'Не удалось подтвердить возраст' };
  }
};

/**
 * Check if user has confirmed age from profile data
 */
export const checkAgeConfirmation = (userData: { isAdult?: boolean } | null): boolean => {
  return userData?.isAdult === true;
};
